"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const styled_components_1 = __importDefault(require("styled-components"));
function EmptyUserOwnGroupList({ className }) {
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'EmptyUserOwnGroupList_Container', children: [(0, jsx_runtime_1.jsx)(StyledTitle, { "$fontSize": 20, "data-e2e": 'EmptyUserOwnGroupList_StyledTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.emptyGroups.title) }), (0, jsx_runtime_1.jsx)(StyledTitle, { "$fontSize": 15, "data-e2e": 'EmptyUserOwnGroupList_StyledTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.emptyGroups.subtitle) })] }));
}
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const StyledTitle = styled_components_1.default.div `
  color: ${({ theme }) => theme.designSystem.textSecondary};
  font-size: ${({ $fontSize }) => $fontSize}px;
`;
exports.default = EmptyUserOwnGroupList;
